<script>
export default {
  name: 'AzureActiveDirectorySSOCallback',
  mounted() {
    if (this.$msal) this.$msal.handleRedirectPromise()
  },
}
</script>

<template lang="pug">
.sso-callback
  .sso-info
    h2.text-primary SSO LOGIN IN PROGRESS
    span.text-danger(v-if="!!error") {{ error }}
  blocker(v-if="blocker")
</template>

<style scoped lang="scss">
.sso-callback {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #67c9bb;
  background: linear-gradient(135deg, #67c9bb 0%, #009bde 100%);
  display: flex;
  align-items: center;
  justify-content: center;

  .sso-info {
    background: white;
    padding: 20px 40px;
    border-radius: 1rem;
    text-align: center;
  }
}
</style>
